module.exports = __webpack_public_path__ + "img/zhiyelogoendeee.92137740.jpg";